var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swiperBox",style:({ position: 'relative', height: _vm.styles.height + 'rem' })},[_c('div',{staticClass:"swiper-container",style:({
      width: _vm.styles.width + 'px',
      position: 'absolute',
      height: _vm.styles.height + 'rem',
      left: '50%',
      marginLeft: '-3.75rem'
    })},[_c('div',{staticClass:"swiper-wrapper"},_vm._l((_vm.sliderData),function(item,index){return _c('div',{key:index,staticClass:"swiper-slide"},[_c('router-link',{attrs:{"to":item.Url,"href":item.Url},nativeOn:{"click":function($event){return _vm.OpenLink(item.Url)}}},[_c('img',{style:({ width: _vm.styles.width + 'px' }),attrs:{"src":item.FileUrl}})])],1)}),0),_vm._v(" "),_c('div',{staticClass:"swiper-pagination"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c5b128c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/slider.vue
// module id = null
// module chunks = 